import { userLanguage, ValidLanguages } from '$translations/index';
import {
  ErrorMessageEn,
  ErrorMessageEs,
  SuccessMessageEn,
  SuccessMessageEs,
} from '../../../../constants/alerts';
import { successHandler, errorHandler } from '../../../utils';
import { CandidateBuilder, DeleteCandidateInput } from '../candidates.types';

export const deleteCandidate = (builder: CandidateBuilder) =>
  builder.mutation<void, DeleteCandidateInput>({
    query: ({ candidateId }) => ({
      url: `/candidates/${candidateId}`,
      method: 'DELETE',
    }),
    transformResponse: () => {
      successHandler(
        userLanguage === ValidLanguages.es
          ? SuccessMessageEs.CANDIDATE_DELETED
          : SuccessMessageEn.CANDIDATE_DELETED,
        true
      );
    },
    transformErrorResponse: (err) => {
      errorHandler(
        '[deleteCandidate]',
        userLanguage === ValidLanguages.es
          ? ErrorMessageEs.DeleteCandidateError
          : ErrorMessageEn.DeleteCandidateError,
        err,
        true
      );
      return err.data;
    },
    invalidatesTags: () => [{ type: 'Candidates' }],
  });
